export default "__VITE_ASSET__1tE02d5Y__"